export default [
    {
        path: '/',
        name: 'home',
        meta: {
            template: 'normal'
        },
        component: () => import('VIEWS/Playground.vue')
    }
]